import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  responseList: [], 
  responseArr: [],
  responseArray: [],
  responseID: '',
  selectedResponse: null,
  selectedInquiry: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.responseList = [];
    state.responseArr = [];
    state.responseArray = [];
    state.responseID = '';
    state.selectedResponse = null;
    state.selectedInquiry = null;
    state.isEditing = false;
  },
  SET_SELECTED_RESPONSE(state, response) {
    state.selectedResponse = response;
    state.isEditing = true;
  },
  SET_SELECTED_INQUIRY(state, inquiry) {
    state.selectedInquiry = inquiry;   
  },
  LIST_RESPONSES(state, responses) {
    state.responseList = responses;
  },
  RESPONSE_ARRAY(state, responseArray){
    state.responseArray = responseArray;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){
    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createInquiryResponse({ commit,state }, formData) {
    return axios.post('api/v1/create-inquiry-response/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchInquiryResponses({ commit,state }, formData) {
    state.responseArr = [];
    axios.post(`api/v1/get-inquiry-responses/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.responseArr.push((response.data[i].message));
      }
      commit('LIST_RESPONSES', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchInquiryResponse({ commit,state }, formData) {
    axios.post(`api/v1/get-inquiry-responses/`,formData)
    .then((response)=>{
        console.log(response.data);
        const selectedInquiry = response.data.inquiry.customer_name + " - Subject: " + response.data.inquiry.subject;
        state.selectedResponse = response.data;
        commit('SET_SELECTED_RESPONSE',state.selectedResponse);
        commit('SET_SELECTED_INQUIRY',selectedInquiry);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedResponse({ commit, state }, option){
    state.responseArray = [];
    const selectedResponse = state.responseList.find(response => (response.message) === option);
    if (selectedResponse) {
        state.responseID = selectedResponse.response_id;
        state.responseArray = [...state.responseArray, selectedResponse];
    }
    commit('RESPONSE_ARRAY', state.responseArray);
      
  },

  async updateInquiryResponse({ commit,state }, formData) {
    return axios.put(`api/v1/update-customer-response/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteInquiryResponse({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete  Response?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Response!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-inquiry-response/`,formData)
        .then((response)=>{
          if(response.data.msg == "Success"){
              Swal.fire("Poof! Response removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Response",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Response has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  